import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  FeatureNames,
  FeaturePropertyKey,
} from '@vi-iot/client/apis/operational-data/operational-data.constants';
import { FeaturesDetailsOverlayTypeEnum } from '../../installation-overlay.model';
import { CommonUIModule } from '@shared-ui';
import { DevicesStore, InstallationFeaturesStore } from '@store';
import { PillType } from 'src/app/shared/components/pill/pill.model';
import { combineLatest, switchMap } from 'rxjs';
import { DryContactConsumptionStatusPipe } from '../dry-contact-feature-tiles/pipes/dry-contact-consumption-status.pipe';
import {
  DeviceNameCommands,
  DeviceNameProperties,
  IsActiveProperty,
  IsNumberValueProperty,
  IsStringValueProperty,
} from '@vi-iot/client/apis/operational-data/operational-data.model';

@Component({
  selector: 'app-dry-contact-generic-feature-tile',
  templateUrl: 'dry-contact-generic-feature-tile.component.html',
  styleUrl: 'dry-contact-generic-feature-tile.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonUIModule, DryContactConsumptionStatusPipe],
})
export class DryContactGenericFeatureTileComponent {
  readonly FeaturePropertyKey = FeaturePropertyKey;
  readonly FeaturesDetailsOverlayTypeEnum = FeaturesDetailsOverlayTypeEnum;
  readonly PillType = PillType;

  deviceFeatures$ = this.deviceStore.selectedDevice$.pipe(
    switchMap((device) =>
      combineLatest({
        deviceNumber: [Number(device.id.split('-').pop() ?? 0)],
        deviceName: this.installationFeaturesStore.selectInstallationDeviceFeature<
          DeviceNameProperties,
          DeviceNameCommands
        >(FeatureNames.deviceName, device.id),
        dryContactOutputSetpoint: this.installationFeaturesStore.selectInstallationDeviceFeature<
          IsActiveProperty,
          unknown
        >(FeatureNames.dryContactOutputSetpoint, device.id),
        dryContactPowerConsumption: this.installationFeaturesStore.selectInstallationDeviceFeature<
          IsNumberValueProperty,
          unknown
        >(FeatureNames.dryContactInstantaneousPower, device.id),
        dryContactConsumptionStatus: this.installationFeaturesStore.selectInstallationDeviceFeature<
          IsStringValueProperty,
          unknown
        >(FeatureNames.dryContactPowerConsumptionStatus, device.id),
      })
    )
  );

  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    private deviceStore: DevicesStore
  ) {}
}
